var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",attrs:{"id":"ClientView"}},[_c('div',{staticClass:"box-tittel"},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(this.tittle))])]),_c('div',{staticClass:"box-100"},[_c('ClientListComponent',{attrs:{"clientList":_vm.$store.getters.getClients}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }